import React from 'react';
import { motion } from 'framer-motion';

const techIcons = [
  { name: 'JavaScript', src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg" },
  { name: 'Node.js', src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg" },
  { name: 'React', src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original-wordmark.svg" },
  { name: 'Python', src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg" },
  { name: 'JSON', src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/json/json-original.svg" },
  { name: 'Next.js', src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg" },
  {name:"Git", src:"https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg"
          }
];

const Techs = () => {
  return (
    <section className="bg-gradient-to-b from-gray-100 to-gray-200 py-20 relative overflow-hidden">
      <div className="container mx-auto text-center">
        <h2 className="text-black text-3xl font-bold mb-10">Tech Stack</h2>
        <div className="relative flex flex-wrap justify-center items-center gap-8">
          {techIcons.map((icon, index) => (
            <motion.div
              key={icon.name}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="inline-block mx-4 cursor-pointer"
            >
              <motion.img
                src={icon.src}
                alt={icon.name}
                className="h-16 w-16 sm:h-24 sm:w-24 "
                whileHover={{ y: -10 }}
                transition={{ duration: 0.3 }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Techs;
